const REQUESTREPLY_PREFIX = '#reqrep/';

export var Requestor = function (dataengine, channel, timeout) {
  timeout = timeout || 3000;
  const pendingRequests = {};

  dataengine.connection.addListener(REQUESTREPLY_PREFIX + channel, '*', true, (ev) => {
    if (pendingRequests[ev.key]) {
      pendingRequests[ev.key](ev.value.err, ev.value.data);
      pendingRequests[ev.key] = null;
    }
  });

  this.request = function (msg) {
    return new Promise((resolve, reject) => {
      const id = generateMessageId();

      dataengine.connection.signalEvent(REQUESTREPLY_PREFIX + channel, id, msg);

      setTimeout(() => {
        pendingRequests[id] = null;
        reject({ timeout: true });
      }, timeout);

      pendingRequests[id] = function (err, data) {
        if (err) {
          reject({ msg: err });
        } else {
          resolve(data);
        }
      };
    });
  };
};

export var Replier = function (dataengine, channel) {
  const _self = this;
  dataengine.connection.addListener(REQUESTREPLY_PREFIX + channel, '*', true, (ev) => {
    _self.onMessage(ev.value, (err, data) => {
      dataengine.connection.signalEvent(REQUESTREPLY_PREFIX + channel, ev.key, { err, data });
    });
  });
};

var generateMessageId = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4() + s4()}-${s4()}-${s4()}-${
    s4()}-${s4()}${s4()}${s4()}`;
};



// WEBPACK FOOTER //
// ./public/js/de.msg.request-reply.js